module.exports = __webpack_public_path__ + "img/section_studio.6566e66b.jpg";